// @flow

type Params = {|
    content: number,
    container: number,
    shift: number,
|};

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const parseShiftToPosition = ({content, container, shift}: Params): number => {
    const maxShift = content - container;
    const isScroll = maxShift > 0;

    if (!isScroll) {
        return 0;
    }

    const position = shift / maxShift;

    return position > 1 ? 1 : position;
};
